import {
  MARQUE_SEARCH_SUCCES,
  MARQUE_SEARCH_ECHEC,
  MARQUE_SEARCH_RESET,
  MARQUE_SEARCH_REQUETTE,
} from "../constantes/marqueConstantes";
export const marqueSearchReducer = (
  state = { marques: [], loading: false },
  action
) => {
  switch (action.type) {
    case MARQUE_SEARCH_REQUETTE:
      return {
        loading: true,
      };
    case MARQUE_SEARCH_SUCCES:
      return { marques: action.payload, loading: false };
    case MARQUE_SEARCH_ECHEC:
      return { erreur: action.payload, loading: false };
    case MARQUE_SEARCH_RESET:
      return { marques: [], loading: false };
    default:
      return state;
  }
};
